export default function useYears(endYear: number = new Date().getFullYear()) {
    const startYear = 2010;
    const years: Array<number> = [];

    for (let index = endYear; index >= startYear; index--) {
        years.push(index);
    }

    return years;
}

